'use client';

import { BuyItAgainCarousel, useQueryBuyItAgain } from '../buy-it-again-carousel';

type CarouselContentProps = {
    readonly header: string;
    readonly subheader?: string;
};

export function CarouselContent({ header, subheader }: CarouselContentProps) {
    const { data: products } = useQueryBuyItAgain({
        input: {
            placement: 'homepage',
            minCount: 2,
            maxCount: 6,
            inventoryList: [],
            excludes: [],
            saleIndicator: true,
        },
    });

    return <BuyItAgainCarousel header={header} subheader={subheader} minCount={2} products={products} />;
}
